import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
const ACTION_VALUES = ['shown', 'accepted', 'snoozed', 'dismissed'];
export const adminListCreatorPromptEventsEndpoint = {
    [dropEndpointIds.ADMIN_LIST_CREATOR_PROMPT_EVENTS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                limit: { type: 'integer', minimum: 1, maximum: 200 },
                cursor: { type: 'string' },
                userId: { type: 'string' },
                dropId: { type: 'string' },
                action: { type: 'string', enum: ACTION_VALUES },
                fromIso: { type: 'string' },
                toIso: { type: 'string' },
            },
            additionalProperties: false,
        },
    },
};
export const adminGetCreatorPromptStatsEndpoint = {
    [dropEndpointIds.ADMIN_GET_CREATOR_PROMPT_STATS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                fromIso: { type: 'string' },
                toIso: { type: 'string' },
                maxRecords: { type: 'integer', minimum: 1, maximum: 5000 },
            },
            additionalProperties: false,
        },
    },
};
const userIdOnlySchema = {
    type: 'object',
    properties: {
        userId: { type: 'string', minLength: 1 },
    },
    required: ['userId'],
    additionalProperties: false,
};
export const adminPreviewCreatorPromptEndpoint = {
    [dropEndpointIds.ADMIN_PREVIEW_CREATOR_PROMPT]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: userIdOnlySchema,
    },
};
export const adminResetCreatorPromptCadenceEndpoint = {
    [dropEndpointIds.ADMIN_RESET_CREATOR_PROMPT_CADENCE]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: userIdOnlySchema,
    },
};
export const adminClearCreatorPromptDismissalsEndpoint = {
    [dropEndpointIds.ADMIN_CLEAR_CREATOR_PROMPT_DISMISSALS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: userIdOnlySchema,
    },
};
export const adminGetCreatorPromptConfigEndpoint = {
    [dropEndpointIds.ADMIN_GET_CREATOR_PROMPT_CONFIG]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {},
            additionalProperties: false,
        },
    },
};
export const adminUpdateCreatorPromptConfigEndpoint = {
    [dropEndpointIds.ADMIN_UPDATE_CREATOR_PROMPT_CONFIG]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                enabled: { type: 'boolean' },
                minIntervalHours: { type: 'number', minimum: 0 },
                snoozeHours: { type: 'number', minimum: 0 },
                dismissDropDays: { type: 'number', minimum: 0 },
                candidatePoolSize: { type: 'integer', minimum: 1 },
                minSimilarityScore: { type: 'number' },
                similarityRatio: { type: 'number', minimum: 0, maximum: 1 },
                showDelaySeconds: { type: 'number', minimum: 0, maximum: 300 },
            },
            additionalProperties: false,
        },
    },
};
export const adminGetDropPromptConfigEndpoint = {
    [dropEndpointIds.ADMIN_GET_DROP_PROMPT_CONFIG]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string', minLength: 1 },
            },
            required: ['dropId'],
            additionalProperties: false,
        },
    },
};
export const adminUpdateDropPromptConfigEndpoint = {
    [dropEndpointIds.ADMIN_UPDATE_DROP_PROMPT_CONFIG]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string', minLength: 1 },
                overrides: {
                    type: 'object',
                    properties: {
                        enabled: { type: 'boolean' },
                        minSimilarityScore: { type: 'number' },
                        similarityRatio: { type: 'number', minimum: 0, maximum: 1 },
                    },
                    additionalProperties: false,
                },
            },
            required: ['dropId', 'overrides'],
            additionalProperties: false,
        },
    },
};
